import { petcoTheme } from './petcoTheme';

const petcoInsuranceColors = {
  blue: '#2A79D6',
  gradientLight: '#42B8EB',
  gradientDark: '#2A79D6',
};

export const petcoInsuranceTheme = {
  ...petcoTheme,
  primary: {
    ...petcoTheme.primary,
    main: petcoInsuranceColors.blue,
  },
  gradient: {
    light: petcoInsuranceColors.gradientLight,
    dark: petcoInsuranceColors.gradientDark,
  },
};
